<template>
    <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center">

        <!-- BACKDROP -->
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="$emit('close')" />

        <!-- MODAL -->
        <div
            class="relative w-full max-w-4xl h-[70vh] mx-4 bg-white dark:bg-gray-900 rounded-xl shadow-2xl overflow-hidden flex">

            <!-- LEFT NAV -->
            <aside class="w-1/3 bg-gray-100 dark:bg-gray-800 p-4 flex flex-col gap-2">

                <h2 class="text-sm font-bold text-gray-500 dark:text-gray-300 mb-2">
                    SETTINGS
                </h2>

                <button @click="$emit('set-active', 'payee')" class="text-left px-3 py-2 rounded-md text-sm transition"
                    :class="activeSetting === 'payee'
                        ? 'bg-[#E87055] text-white'
                        : 'hover:bg-gray-200 dark:hover:bg-gray-700'">
                    Manage Payee Details
                </button>

                <button @click="$emit('set-active', 'users')" class="text-left px-3 py-2 rounded-md text-sm transition"
                    :class="activeSetting === 'users'
                        ? 'bg-[#E87055] text-white'
                        : 'hover:bg-gray-200 dark:hover:bg-gray-700'">
                    Manage Users
                </button>

            </aside>

            <!-- RIGHT VIEW -->
            <section class="flex-1 p-6 overflow-y-auto">

                <!-- HEADER -->
                <div class="flex justify-between items-center mb-4">
                    <h3 class="text-lg font-semibold">Settings</h3>

                    <button @click="$emit('close')" class="text-gray-500 hover:text-red-500">
                        ✕
                    </button>
                </div>

                <!-- PAYEE -->
                <PayeeSettings v-if="activeSetting === 'payee'" />

                <!-- USERS -->
                <UserSettings v-else-if="activeSetting === 'users'" />

            </section>
        </div>
    </div>
</template>

<script>
import PayeeSettings from "./PayeeSettings.vue";
import UserSettings from "./UserSettings.vue";

export default {
    props: {
        show: Boolean,
        activeSetting: String
    },
    emits: ["close", "set-active"],
    components: {
        PayeeSettings,
        UserSettings
    }
};
</script>